// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"75414603","308":"e3b44c5a","353":"e0c55ed4","398":"0bd586ee","956":"f6671ef2"}[chunkId] + ".chunk.css";
};